import React from "react";

import FormsyComposedNewRadioGroup from "../../../../../../../lib/FormBuilder/FormsyMaterialUI/FormsyComposedNewRadioGroup";
import ApiHelper from "../../../../../../../lib/UniversalTable/CoreHelpers/ApiHelper";

class SingleRadioFilter extends React.Component {
  render() {
    const { column, value, onChange } = this.props;
    const options = column.filter_data || [];
    const attr = ApiHelper.getColumnAttributeForFiltering(column);

    return (
      <div className="filters-item-wrapper half-width radio-filter">
        <FormsyComposedNewRadioGroup
          name={attr}
          label={column.label}
          options={options}
          value={value}
          onChange={onChange}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default SingleRadioFilter;
